import Associated from "../entities/Associated";

export function isInLatePaymentState(associated:Associated):boolean{
  let credits = associated.credits ? Number(associated.credits) : 0;
  return credits <= 20;
}